import './i18n';
import './index.scss';
import App from './App';
import React from 'react';
import 'slick-carousel/slick/slick.css'; 
import 'bootstrap/dist/css/bootstrap.css';
import { createRoot } from 'react-dom/client';
import 'slick-carousel/slick/slick-theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
